import IAddress from "./IAddress";
import Address from "./Address";
import IBlock3Entrepreneur from "./IBlock3Entrepreneur";
import EnumUtil from "@/app/util/Enum";

export default class Block3Entrepreneur implements IBlock3Entrepreneur {
    constructor(
        public address: IAddress = new Address(),
        public businessArea: string = EnumUtil.EMPTY_OPTION,
        public businessName: string = "",
        public businessId: string = "",
    ) {
    }
}